import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"d-flex flex-column h-100\">\n  {{outlet}}\n</div>\n",{ moduleName: "eflex/pods/parts/template.hbs" })